<template>
  <div class="t-24 fw-7">Edit Votes</div>
  <div class="f-w w-100p m-tx6">
    <div v-for="vote in votes" :key="vote.id" class="f-ac f-sb m-rx6 m-bx6">
      <div class="t-16 m-rx1">{{ vote.name }}</div>
      <InputsToggle :model-value="vote.active" @update:modelValue="onToggle($event, vote.id)" />
    </div>
  </div>
  <div class="f m-tx6">
    <input class="input-text w-x50" v-model="passkey" placeholder="Admin Passkey">
    <button class="m-lx1 button" @click="submit">Submit</button>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import axios from 'axios';
  
  import { useModalStore } from '../../../stores/modal_store';
  const modalStore = useModalStore();

  import { useToastStore } from '../../../stores/toast_store';
  const toastStore = useToastStore();

  const votes = ref([])

  const onToggle = (event, voteId) => {
    const vote = votes.value.find(v => v.id === voteId);
    vote.active = event;
  };

  const passkey = ref('');
  const submit = () => {
    const params = {
      poll: {
        votes: votes.value.map((vote) => {
          return { id: vote.id, state: vote.active ? 'active' : 'inactive' };
        }),
      },
      passkey: passkey.value,
    };
    axios.post(`/polls/${modalStore.data.poll.id}/update_votes`, params).then(
      ({ data }) => {
        toastStore.setSuccessToast({ text: 'Votes successfully edited' });
        modalStore.data.onSubmit(data.poll);
        modalStore.closeModal();
      },
      (error) => {
        console.log('error', error);
        toastStore.setErrorToast({ text: error.response.data.message });
        modalStore.closeModal();
      },
    );
  };

  onBeforeMount(() => {
    modalStore.data.poll.votes.sort((a, b) => {
      return a.voter_name.toLowerCase().localeCompare(b.voter_name.toLowerCase())
    }).forEach((v) => {
      votes.value.push({ id: v.id, name: v.voter_name, active: v.state === 'active' });
    });
  });
</script>